import { render, staticRenderFns } from "./SignatureCard.vue?vue&type=template&id=096c97aa&scoped=true&"
import script from "./SignatureCard.vue?vue&type=script&lang=js&"
export * from "./SignatureCard.vue?vue&type=script&lang=js&"
import style0 from "./SignatureCard.vue?vue&type=style&index=0&id=096c97aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096c97aa",
  null
  
)

export default component.exports